import styled from 'styled-components';
import { getStyles } from '../../utils/getStyles/getStyles';
export const ButtonStyled = styled.button ``;
export const ListOptionsWrapperStyled = styled.div `
  ${({ styles }) => getStyles(styles.parentContainer)}
`;
export const TitleWrapperStyled = styled.div `
  ${({ styles }) => getStyles(styles.titleContainer)}
`;
export const OptionsWrapperStyled = styled.div `
  ${({ styles }) => getStyles(styles.optionsContainer)}
`;
//# sourceMappingURL=listOptions.styled.js.map